module.exports = __webpack_public_path__ + "static/media/psiquiatra-mobile.18179f32.png";